export enum EEARType {
    INDIVIDUALS,
    BUILDINGS
}

export class EEARTypeHelper{
    public static getEEARTypeLabelFromNumber(type: number):string {
        switch (type) {
            case EEARType.INDIVIDUALS:
                return 'individuals';
            case EEARType.BUILDINGS:
                return 'buildings';
            default:
                return '';
        }
    }

    public static getEEARTypeLabel(type: EEARType):string {
        switch (type) {
            case EEARType.INDIVIDUALS:
                return 'Individuals';
            case EEARType.BUILDINGS:
                return 'Buildings';
            default:
                return '';
        }
    }
}